import { defineMessages } from 'react-intl';

export default defineMessages({
    renewalSurveyFormWithPolicy: {
        id: 'tdic.survey.detail.Policy Questionnaire for Policy',
        defaultMessage: 'Policy Questionnaire for Policy {policyNumber}',
    },
    renewalSurveyForm: {
        id: 'tdic.survey.detail.Policy Questionnaire',
        defaultMessage: 'Policy Questionnaire',
    },
    renewalSurvey: {
        id: 'tdic.survey.detail.Please fill the Policy Questionnaire for Policy Number',
        defaultMessage: 'Please fill the Policy Questionnaire for policy Number {policyNumber}',
    },
    questionnaire: {
        id: 'tdic.survey.detail.Questionnaire',
        defaultMessage: 'Questionnaire',
    },
    termsAndCondition: {
        id: 'tdic.survey.detail.Terms and Conditions',
        defaultMessage: 'Terms and Conditions',
    },
    nameOfIndividual: {
        id: 'tdic.survey.detail.Name of Individual completing the Survey',
        defaultMessage: 'tdic.survey.detail.Name of Individual completing the Survey',
    },
    submit: {
        id: 'tdic.survey.detail.Submit',
        defaultMessage: 'Submit',
    },
    acknowledgement: {
        id: 'tdic.survey.detail.Your Policy Questionnaire form for Policy Number {policyNumber} has been submitted successfully',
        defaultMessage: 'Your Policy Questionnaire form for Policy Number {policyNumber} has been submitted successfully',
    },
    ok: {
        id: 'tdic.survey.detail.Ok',
        defaultMessage: 'Ok',
    },
    admisterSurvey: {
        id: 'tdic.survey.questions.Do you administer or treat patients under any of the anesthetic modalities listed below? (Check all that apply)',
        defaultMessage: 'Do you administer or treat patients under any of the anesthetic modalities listed below? (Check all that apply)'
    },
    acknowledgementSurvey: {
        id: 'tdic.survey.questions.I certify that all statements made in this form are complete and accurate to the best of my knowledge, and I authorize TDIC to verify the information provided.',
        defaultMessage: 'I certify that all statements made in this form are complete and accurate to the best of my knowledge, and I authorize TDIC to verify the information provided.'
    },
    plSurvey: {
        id: 'tdic.survey.detail.Professional Liability Policy Review',
        defaultMessage: 'Professional Liability Policy Review',
    },
    eplSurvey: {
        id: 'tdic.survey.detail.Employment Practices Liability Policy Review',
        defaultMessage: 'Employment Practices Liability Policy Review',
    },
    anesthesiarenewalSurvey: {
        id: 'tdic.survey.detail.Anestesia Renewal Survey',
        defaultMessage: 'Renewal Survey - Anesthesia & Speciality',
    },
    confirmationSurveyWithPolicy: {
        id: 'tdic.survey.detail.Your Policy Questionnaire form for Policy Number {policyNumber} has been submitted successfully',
        defaultMessage: 'Your Policy Questionnaire form for Policy Number {policyNumber} has been submitted successfully',
    },
    confirmationSurvey: {
        id: 'tdic.survey.detail.Your Policy Questionnaire form has been submitted successfully',
        defaultMessage: 'Your Policy Questionnaire form has been submitted successfully',
    },
    haveCompletedDentalSpecialty: {
        id: 'tdic.policyquestionnaire.Have you completed a dental specialty program?',
        defaultMessage: '1. Have you completed a dental specialty program?'
    },
    dentalSpecialty: {
        id: 'tdic.policyquestionnaire.Dental Specialty',
        defaultMessage: '1a. Dental Specialty'
    },
    specialtySchoolAttended: {
        id: 'tdic.policyquestionnaire.Specialty School Attended',
        defaultMessage: '1b. Specialty School Attended'
    },
    yearSpecialtyTrainingCompleted: {
        id: 'tdic.policyquestionnaire.Year Specialty Training Completed',
        defaultMessage: '1c. Year Specialty Training Completed'
    },
    othersAdministerAnesthetic: {
        id: 'tdic.policyquestionnaire.Does anyone else administer?',
        defaultMessage: '3. Does anyone else administer any of the anesthetic modalities listed below?'
    },
    isConsciousSedationAdministered: {
        id: 'tdic.policyquestionnaire.Is conscious sedation administered?',
        defaultMessage: '4. Is conscious sedation (including IV or IM) or general anesthesia in a hospital or surgicenter, administered by a dental anesthesiologist, M.D. anesthesiologist, CRNA or oral maxillofacial surgeon to your patients?'
    },
    typeOfSpecialistAdministeringAnesthesia: {
        id: 'tdic.policyquestionnaire.Type of specialist',
        defaultMessage: '4a. Type of specialist administering anesthesia in a hospital to your patients'
    },
    isConsciousSedationInOfficeAdministered: {
        id: 'tdic.policyquestionnaire.Is conscious sedation in office administered?',
        defaultMessage: '5. Does someone administer IV or IM Sedation in office?'
    },
    ivImSedationAdministeredBy: {
        id: 'tdic.policyquestionnaire.Please indicate who administers IV IM Sedation',
        defaultMessage: 'Please indicate who administers IV IM Sedation in office:'
    },
    ivImSedationName: {
        id: 'tdic.policyquestionnaire.IV IM Sedation Name',
        defaultMessage: '5a. Name'
    },
    ivImSedationLicenseNumber: {
        id: 'tdic.policyquestionnaire.IV IM Sedation License Number',
        defaultMessage: '5b. License Number'
    },
    ivImSedationSpecialty: {
        id: 'tdic.policyquestionnaire.IV IM Sedation Specialty',
        defaultMessage: '5c. Specialty'
    },
    isGeneralAnesthesiaAdministered: {
        id: 'tdic.policyquestionnaire.Is general anesthesia administered?',
        defaultMessage: '6. Does someone administer general anesthesia in office??'
    },
    generalAnesthesiaAdministeredBy: {
        id: 'tdic.policyquestionnaire.Please indicate who administers general anesthesia',
        defaultMessage: 'Please indicate who administers general anesthesia in office:'
    },
    generalAnesthesiaName: {
        id: 'tdic.policyquestionnaire.General Anesthesia Name',
        defaultMessage: '6a. Name'
    },
    generalAnesthesiaLicenseNumber: {
        id: 'tdic.policyquestionnaire.General Anesthesia License Number',
        defaultMessage: '6b. License Number'
    },
    generalAnesthesiaSpecialty: {
        id: 'tdic.policyquestionnaire.General Anesthesia Specialty',
        defaultMessage: '6c. Specialty'
    }
});
